import { normalizeError, ValidateEmailError } from 'core/common/errors';

import { AppThunk } from 'core/common/store';

export const validateEmailRequest =
  (email: string): AppThunk =>
  async (_, __, context) => {
    const { emailManagerService, loggingService } = context;

    try {
      const isValidEmail = await emailManagerService.isValidEmail(email);

      if (!isValidEmail) {
        throw new ValidateEmailError('Incorrect email address');
      }
    } catch (err) {
      const error = normalizeError(err);
      loggingService.error(error);
      throw error;
    }
  };
